import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getStateSlice = createAsyncThunk(
  "state/getState",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/state/getState",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
);

const initialState = {
  loading: false,
  state: [],
};

const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStateSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStateSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.state = action.payload.result.list;
      })
      .addCase(getStateSlice.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default stateSlice.reducer;
